var _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicense20Grey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8536",
    "data-name": "Group 8536",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M168.543,47.242c-5.853-1.592-7.6-3.828-7.621-3.849a.467.467,0,0,0-.743,0c-.017.022-1.77,2.259-7.622,3.851a.455.455,0,0,0-.338.437v6.763c0,.014,0,.028,0,.043.022.229.625,5.63,8.172,8.322a.467.467,0,0,0,.314,0c7.547-2.692,8.15-8.093,8.172-8.322,0-.014,0-.028,0-.043V47.679a.454.454,0,0,0-.338-.437Zm-.583,7.174c-.041.325-.759,5.04-7.41,7.481-6.682-2.452-7.364-7.1-7.41-7.48v-6.4c4.53-1.283,6.633-2.932,7.41-3.687.776.755,2.88,2.4,7.41,3.687Z",
    transform: "translate(-152.22 -43.208)",
    fill: "#727171"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_1104",
    "data-name": "Path 1104",
    transform: "translate(9 10)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.5 12.5 C 3.191590070724487 12.5 0.5 9.808409690856934 0.5 6.5 C 0.5 3.191590070724487 3.191590070724487 0.5 6.5 0.5 C 9.808409690856934 0.5 12.5 3.191590070724487 12.5 6.5 C 12.5 9.808409690856934 9.808409690856934 12.5 6.5 12.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.5 1 C 3.467289924621582 1 1 3.467289924621582 1 6.5 C 1 9.532710075378418 3.467289924621582 12 6.5 12 C 9.532710075378418 12 12 9.532710075378418 12 6.5 C 12 3.467289924621582 9.532710075378418 1 6.5 1 M 6.5 0 C 10.0898494720459 0 13 2.910149574279785 13 6.5 C 13 10.0898494720459 10.0898494720459 13 6.5 13 C 2.910149574279785 13 0 10.0898494720459 0 6.5 C 0 2.910149574279785 2.910149574279785 0 6.5 0 Z",
    stroke: "none",
    fill: "#727171"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-5601922_1_",
    "data-name": "noun-user-5601922 (1)",
    transform: "translate(12.516 13.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M234.785,46.668a1.455,1.455,0,1,0,1.455,1.455A1.455,1.455,0,0,0,234.785,46.668Z",
    transform: "translate(-231.875 -46.668)",
    fill: "#727171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M118.957,303.33a2.287,2.287,0,0,0-2.287,2.287.333.333,0,0,0,.333.333h5.16a.329.329,0,0,0,.329-.329,2.291,2.291,0,0,0-2.291-2.291Z",
    transform: "translate(-116.67 -300.128)",
    fill: "#727171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense20Grey);
export default __webpack_public_path__ + "static/media/license2.0_grey.2f588a4e39d1c3c753d58b9b2bddccf5.svg";
export { ForwardRef as ReactComponent };